export class CourseProductMapper {
  static toProductCode(courseCode?: string | null): string {
    if (!courseCode) {
      return '';
    }
    if (courseCode === 'enBs') return 'en.bs';
    if (courseCode === 'enKids') return 'en.ch';
    if (courseCode === 'es') return 'sp';
    if (courseCode === 'en3') return 'en3';
    if (courseCode.startsWith('en.bs.')) return 'en.bs';
    if (courseCode.startsWith('en.ch.')) return 'en.ch';
    if (courseCode.startsWith('en.')) return 'en';
    if (courseCode.startsWith('sp.')) return 'sp';
    const firstDot = courseCode.indexOf('.');
    return firstDot > 0 ? courseCode.substring(0, firstDot) : courseCode;
  }
}
